import { render } from "./OrderTrackingPage.vue?vue&type=template&id=2892e8bd&scoped=true"
import script from "./OrderTrackingPage.vue?vue&type=script&lang=js"
export * from "./OrderTrackingPage.vue?vue&type=script&lang=js"

import "./OrderTrackingPage.vue?vue&type=style&index=0&id=2892e8bd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2892e8bd"]])

export default __exports__